import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { howToGroup } from "@signals"


export default function AppCommonFiltersHowToGroupAutocomplete({ ...props }) {
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		value={howToGroup.value}
		onChange={e => howToGroup.value = e.target.value}
		label="How to group"
		placeholder="Group search results"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/bi-options?service_type=bi`}
		{...props}
	/>
}